import {CAR_OWNER_TYPE_OPTIONS, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import KnownRegNumberFields from "./parts/known-reg-number-fields";
import UnKnownRegNumberFields from "./parts/unknown-reg-number-fields";
import CarModifications from "./parts/car-modications";
import CarPurchaseInfo from "./parts/car-purchase-info";

import CarUsage from "./parts/car-usage";
import {ValidateStep3Data} from "@validators/car-insurance-form/step3-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import React from "react";

export default function IF_Step4({data, handlers, setCurrentStep}) {

    const STEP = 3;

    const onPrevBtnClick = (event) => {
        setCurrentStep(STEP - 1);
    }

    const onNextBtnClick = (event) => {

        let validationResult = ValidateStep3Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult: validationResult
            });


        } else {
            setCurrentStep(STEP + 1);
        }


    }

    return (
        <div className={`if-step-${STEP}`}>

            <SectionHeading
                text="Car info"
            />


            <div className="row">

                {/* Do you know car registration number? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Do you know car registration number?"
                    required={true}
                    controlName="isCarRegistrationNumKnown"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isCarRegistrationNumKnown}
                    onChange={handlers.onControlChange}
                />

            </div>

            {data.isCarRegistrationNumKnown === 'Yes' && <KnownRegNumberFields
                data={data}
                handlers={handlers}
            />}

            {data.isCarRegistrationNumKnown === 'No' && <UnKnownRegNumberFields
                data={data}
                handlers={handlers}
            />}

            {/*
                Modifications info ...
            */}

            <CarModifications
                data={data}
                handlers={handlers}
            />

            <div className="row">
                {/* Is the car imported? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 extra"
                    labelText="Is the car imported?"
                    required={true}
                    controlName="wasCarImported"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.wasCarImported}
                    onChange={handlers.onControlChange}
                />
            </div>

            {/*
                Purchase Info ...
            */}

            <CarPurchaseInfo
                data={data}
                handlers={handlers}
            />

            
            <div className="row">

                {/* Who is the registered keeper? */}

                <ScrollableDropdownBlock
                    controlName="registeredKeeper"
                    containerCssClass="col-12 py-3 "
                    labelText="Who is the registered keeper?"
                    required={true}
                    options={CAR_OWNER_TYPE_OPTIONS}
                    selectedValues={data.registeredKeeper}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Who is the legal owner? */}

                <ScrollableDropdownBlock
                    controlName="legalOwner"
                    containerCssClass="col-12 py-3 "
                    labelText="Who is the legal owner?"
                    required={true}
                    options={CAR_OWNER_TYPE_OPTIONS}
                    selectedValues={data.legalOwner}
                    onChange={handlers.onControlChange}
                    helpText=""
                />
               
               {/* Is the car on finance (Hire purchase/CPC)? */}
               
               <ScrollableButtonGroupBlock
                  containerCssClass="col-12 py-3"
                  labelText="Is the car on finance (Hire purchase/CPC)?"
                  required={true}
                  controlName="isTheCarOnFinance"
                  options={YES_NO_CHOICE_OPTIONS}
                  selectedValues={data.isTheCarOnFinance}
                  onChange={handlers.onControlChange}
               />


                {/* Is the car impounded with police? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Is the car impounded with police?"
                    required={true}
                    controlName="carImpoundedWithPolice"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.carImpoundedWithPolice}
                    onChange={handlers.onControlChange}
                />

            </div>


            {/*
                Car usage ...
            */}

            <CarUsage
                data={data}
                handlers={handlers}
            />

            {/*
                Step buttons ....
            */}

           {/* <div className="row mt-5">
                <div className="col d-flex justify-content-between">

                    <PreviousButtonComponent
                        onClick={onPrevBtnClick}
                    />

                    <NextButtonComponent
                        onClick={onNextBtnClick}
                    />

                </div>
            </div>*/}
           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              nextButtonAdditionalCssClass={``}
           />
        </div>
    );

}